import { InternalAxiosRequestConfig } from 'axios';

import { getCurrentLanguage } from '@/locales';

export function localeInterceptor(
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig {
  if (!config.headers['Accept-Language']) {
    config.headers['Accept-Language'] = getCurrentLanguage();
  }

  return config;
}
